import styled, { css } from 'styled-components';

import { grid } from '@components/Styled/mixins';

const BadgeContainer = styled.div`
  ${grid()};

  width: 100%;
  align-self: self-start;
  grid-template-columns: repeat(2, min-content);
  justify-content: space-between;
  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(1)} 0`};
  transition: opacity 1s;

  ${({ isCardSelected }) => isCardSelected && css`
    opacity: 0;
  `};
`;

export { BadgeContainer };
